import { api } from '@/api';

// role: [AGENT, RECOMMENDER]
// requestType: [ROLE, REFERRAL_CODE]

const setRefferalCode = ({ investorId, code, role }) => {
  switch (role) {
    case 'INVESTOR': {
      return api.post('/api/kyc/v1/admin/referralCodes', {
        investorId,
        clientCode: code
      });
    }
    case 'AGENT': {
      return api.post('/api/kyc/v1/admin/referralCodes', {
        investorId,
        referralCodeAgent: code
      });
    }
    case 'RECOMMENDER': {
      return api.post('/api/kyc/v1/admin/referralCodes', {
        investorId,
        referralCodeRecommender: code
      });
    }
  }
};

const getInvestorRequest = ({ investorId, role, requestType }) =>
  api.get('/api/kyc/v1/admin/requestCheck', { params: { investorId, role, requestType } });

const resolveRequest = (id) => api.post('/api/kyc/v1/admin/requestCheck', { requestCheckId: id });

const setReferralCodeAgent = ({ investorId, referralCodeAgent }) =>
  api.post('/api/kyc/v1/admin/setReferralCodeAgent', {
    investorId: investorId,
    referralCodeAgent: referralCodeAgent
  });

const deleteReferralCodeAgent = ({ investorId, agentId }) =>
  api.delete('/api/kyc/v1/admin/delReferralCodeAgent', {
    data: {
      investorId: investorId,
      agentId: agentId
    }
  });

const setReferralCodeRecommender = ({ investorId, referralCodeRecommender }) =>
  api.post('/api/kyc/v1/admin/setReferralCodeRecommender', {
    investorId: investorId,
    referralCodeRecommender: referralCodeRecommender
  });

const deleteReferralCodeRecommender = ({ investorId, recommenderId }) =>
  api.delete('/api/kyc/v1/admin/delReferralCodeRecommender', {
    data: {
      investorId: investorId,
      recommenderId: recommenderId
    }
  });

const getRecommendersList = ({ investorId }) =>
  api.get('/api/kyc/v1/admin/recommenders', { params: { investorId } });

const getAgentsList = ({ investorId }) =>
  api.get('/api/kyc/v1/admin/agents', { params: { investorId } });

const getReferralsList = ({ investorId, role }) => {
  switch (role) {
    case 'AGENT': {
      return api.get('/api/kyc/v1/admin/agent/investors', { params: { agentId: investorId } });
    }
    case 'RECOMMENDER': {
      return api.get('/api/kyc/v1/admin/recommender/investors', {
        params: { recommenderId: investorId }
      });
    }
  }
};
const getReferralsTree = ({ investorId }) => {
  return api.get('/api/kyc/v1/admin/investor/pyramid/down', { params: { investorId: investorId } });
};
const findReferralByCode = ({
  referralCodeAgent,
  referralCodeRecommender,
  skip,
  take,
  reverse
}) => {
  return api.get('/api/kyc/v1/admin/referralCode/investors', {
    params: { referralCodeAgent, referralCodeRecommender, skip, take, reverse }
  });
};

export const adminReferralApi = {
  setRefferalCode,
  getInvestorRequest,
  resolveRequest,
  setReferralCodeAgent,
  deleteReferralCodeAgent,
  setReferralCodeRecommender,
  deleteReferralCodeRecommender,
  getRecommendersList,
  getAgentsList,
  getReferralsList,
  getReferralsTree,
  findReferralByCode
};

export const adminReferralApiKeys = {
  getInvestorRequest: 'adminReferralApi.getInvestorRequest',
  getRecommendersList: 'adminReferralApi.getRecommendersList',
  getAgentsList: 'adminReferralApi.getAgentsList',
  getReferralsList: 'adminReferralApi.getReferralsList',
  getReferralsTree: 'adminReferralApi.getReferralsTree'
};
